import request from '@/utils/request2'

// 获取配置信息
export const getConfigInfo = (settingKey) => request({
  url: '/setting/getSettingByKey',
  method: 'get',
  params: { settingKey }
})
// 获取验证码
export const getVerifyCode = (data) => request({
  url: '/open/login/getVerifyCode',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 账号登录
export const accountLogin = (data) => request({
  url: '/bd/user/login',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 手机登录
export const phoneLogin = (data) => request({
  url: '/open/login/loginWithMobile',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})